// config/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBXl1GCeju4cT47_HN9R350bTEaKIUA9hU",
  authDomain: "beauty-salon-b2e61.firebaseapp.com",
  projectId: "beauty-salon-b2e61",
  storageBucket: "beauty-salon-b2e61.firebasestorage.app",
  messagingSenderId: "747054383182",
  appId: "1:747054383182:web:23bce2200028b124b8031f",
  measurementId: "G-7BFJZL1NG9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firestore
export const db = getFirestore(app);
export default app;
// Google authentication
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);